<div class="gl-page">
  <!-- Back link -->
  <yds-button-back
    class="glg-back"
    text="Ga terug 'Overzicht Grootboekrekeningengroep'"
    (back)="goBack()"
  />

  <!-- Title + page actions -->
  <div class="gl-page__header">
    <h1 class="gl-page__title">Grootboekrekeningengroep</h1>
    <div class="gl-page__header-actions">
      @if (!isAddMode()) {
        <yds-button (click)="goToGeneralLedger()">Grootboek</yds-button>
        <yds-button (click)="goToGeneralLedgerAccount()">Grootboekrekening</yds-button>
        <yds-button variant="destructive" (click)="onDelete()">Verwijderen</yds-button>
      }
    </div>
  </div>

  @if (isLoading()) {
    <div class="gl-detail-loading">
      <yds-spinner [label]="'Grootboekrekeningengroep laden...'" />
    </div>
  } @else {
  <!-- Details card -->
  <yds-card-editable
    title="Details"
    [(editing)]="detailsEditing"
    [nextDisabled]="isSaving() || form.invalid"
    [nextLabel]="'Opslaan'"
    [editDisabled]="isLoading() || notFound()"
    (cancel)="onDetailsCancel()"
    (next)="onDetailsNext()"
  >
    @if (notFound()) {
      <p class="glg-empty">Er zijn geen details voor Grootboekrekeningengroep gevonden.</p>
    } @else if (detailsEditing()) {
      <form class="gl-form" [formGroup]="form">
        <p class="gl-form__required-hint">
          Velden gemarkeerd met een sterretje
          (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht.
        </p>

        <div class="gl-field">
          <label class="gl-field__label">
           <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Omschrijving 
          </label>
          <div class="gl-field__control">
            <yds-text-field
              formControlName="generalLedgerGroupName"
              [required]="true"
              [hasError]="isInvalid(form.get('generalLedgerGroupName'))"
              [errorMsg]="'Omschrijving is verplicht.'"
              [placeholder]="'Voer een omschrijving in'"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">
           <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Begindatum 
          </label>
          <div class="gl-field__control">
            <yds-date-picker
              formControlName="startDate"
              [required]="true"
              [locale]="translate.getCurrentLang()"
              [placeholder]="'dd-mm-jjjj'"
              [allowTodayAction]="false"
              [dateFilter]="firstDayOfMonthFilter"
              [dateFilterError]="'Begindatum moet de eerste dag van de maand zijn.'"
              [errorMessage]="
                isInvalid(form.get('startDate'))
                  ? 'Begindatum is verplicht.'
                  : form.hasError('startBeforeEnd') && form.get('startDate')?.touched
                    ? 'Begindatum moet voor einddatum liggen'
                    : ''
              "
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Einddatum</label>
          <div class="gl-field__control">
            <yds-date-picker
              formControlName="endDate"
              [locale]="translate.getCurrentLang()"
              [placeholderKey]="null"
              [placeholder]="''"
              [allowTodayAction]="false"
              [dateFilter]="lastDayOfMonthFilter"
              [dateFilterError]="'Einddatum moet de laatste dag van de maand zijn.'"
              [errorMessage]="
                form.hasError('startBeforeEnd') && form.get('endDate')?.touched
                  ? 'Begindatum moet voor Einddatum liggen'
                  : ''
              "
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Memo</label>
          <div class="gl-field__control">
            <yds-text-area
              formControlName="memoValue"
              [placeholder]="'Voer een memo in'"
              [maxLength]="500"
              [showCounter]="true"
            />
          </div>
        </div>
      </form>
    } @else {
      <div class="gl-detail">
        <div class="gl-detail__row">
          <span class="gl-detail__label">Omschrijving</span>
          <span class="gl-detail__value">{{ groupName() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Begindatum</span>
          <span class="gl-detail__value">{{ startDateDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Einddatum</span>
          <span class="gl-detail__value">{{ endDateDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Memo</span>
          <span class="gl-detail__value gl-detail__value--memo">{{ memoDisplay() }}</span>
        </div>
      </div>
    }
  </yds-card-editable>
  }
</div>
